import { css } from "emotion";

const H1 = ({
  color = "#323232",
  marginTop = 0,
  marginBottom = 0,
  maxWidth = "none",
  breakpoint = 600,
  marginBottomMobile = 0,
  marginTopMobile = 0,
  children
}) => {
  const styles = css({
    fontWeight: 600,
    fontSize: 36,
    color: color,
    marginTop: marginTop,
    marginBottom: marginBottom,
    maxWidth: maxWidth,
    "@media(max-width: 600px)": {
      fontSize: 22
    }
  });

  return <h1 className={styles}>{children}</h1>;
};

export default H1;
